import { Component } from 'react'
import PropTypes from 'prop-types'
import { FullStoryClient } from 'react-fullstory-component'

class FullStoryIntegration extends Component {

  componentDidMount () {
    if (window.location.href.indexOf('app.whimm.co') === -1) return

    const unsubscribe = this.context.store.subscribe(() => {
      const user = this.context.store.getState().user
      if (user.name && user.email) {
        unsubscribe()

        // console.log('Starting FullStory client...', window, document)
        const client = new FullStoryClient({
          debug: false,
          host: 'www.fullstory.com',
          orgKey: '4XX4B'
        }, window)
        client.render()
        client.setSession(user.id, {
          displayName: user.name,
          email: user.email,
          company: user.companyName
        })
      }
    })
  }

  render () {
    return null
  }
}

FullStoryIntegration.contextTypes = {
  store: PropTypes.object,
}

export default FullStoryIntegration



// WEBPACK FOOTER //
// ./src/components/FullStoryIntegration.js